// Copyright (c) 2016 Deere & Company

import JdpClaim from './components';
import actionCreators from './action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    ...state.claims.jdp,
    isCkcCustomerFailed: state.customerFailed.ckcCustomerFailed,
    latestPerUnitMeasurements: state.latestPerUnitMeasurements,
    user: state.user.details,
    warranties: state.productDetails.warranties
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    const queryParams = parentProps.location.query;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        queryParams,
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(JdpClaim);



// WEBPACK FOOTER //
// ./src/claim/marketing/jdp/state-connector.js